var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"absolute":"","color":"#EAF8F1"}},[_c('fulfilling-bouncing-circle-spinner',{attrs:{"animation-duration":3000,"size":60,"color":"#0A9971"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }